export enum ActionTypeEnum {
    ROLE_UPDATE="ROLE UPDATE",
    STATUS_CHANGE="STATUS CHANGE",
    PERSONAL_DETAIL_CHANGE="PERSONAL DETAIL CHANGE",
    ROLE_DELETE="ROLE DELETE"
}

